import { Component, ContentChild, Directive, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ButtonComponent } from '@syncfusion/ej2-angular-buttons';
import { GridComponent, RecordDoubleClickEventArgs } from '@syncfusion/ej2-angular-grids';
import { TextBoxComponent } from '@syncfusion/ej2-angular-inputs';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { PesquisaBaseService } from '../pesquisa-base.service';
import { Subject } from 'rxjs';


@Directive({
  selector: '[appFiltroPesquisa]',
})
export class FiltroPesquisaDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}

@Directive({
  selector: '[appConteudoPesquisa]',
})
export class ConteudoPesquisaDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}

@Directive({
  selector: '[appGridPesquisa]',
})
export class GridPesquisaDirective {
  constructor(public grid: GridComponent) {}
}

@Directive({
  selector: '[appItemFocadoFiltroPesquisa]',
})
export class ItemFocadoFiltroPesquisaDirective {
  constructor(public item: TextBoxComponent) {}
}

@Directive({
  selector: '[appBotaoFocadoFiltroPesquisa]',
})
export class BotaoFocadoFiltroPesquisaDirective {
  constructor(public item: ButtonComponent) {}
}

@Component({
  selector: 'app-pesquisa-base',
  templateUrl: './pesquisa-base.component.html',
  styleUrls: ['./pesquisa-base.component.less']
})
export class PesquisaBaseComponent implements OnInit {

  public estaEmTelaCheia: boolean = false;

  @ContentChild(FiltroPesquisaDirective)
  filtroDiretiva: FiltroPesquisaDirective | null = null;

  @ContentChild(ConteudoPesquisaDirective)
  conteudoDiretiva!: ConteudoPesquisaDirective;

  @ContentChild(ItemFocadoFiltroPesquisaDirective)
  itemFocadoDiretiva: ItemFocadoFiltroPesquisaDirective | null = null;

  @ContentChild(BotaoFocadoFiltroPesquisaDirective)
  botaoFocadoDiretiva: BotaoFocadoFiltroPesquisaDirective | null = null;

  private _gridDiretiva: GridPesquisaDirective | null = null;
  
  @ContentChild(GridPesquisaDirective)
  set gridDiretiva(valor: GridPesquisaDirective | null) {
    this._gridDiretiva = valor;
    if(!this._gridDiretiva?.grid)
      return;

    this._gridDiretiva.grid.recordDoubleClick.subscribe((args: RecordDoubleClickEventArgs) => {
      this.registroSelecionado.emit(args.rowData);
      this.fechar();
    });
  }

  get gridDiretiva(): GridPesquisaDirective | null {
    return this._gridDiretiva;
  } 

  @Output()
  public abriuModal: boolean = false;

  @Input()
  titulo: string = '-';

  @Input()
  largura: string = "98%";

  @Input()
  altura: string = "95%";

  @Input()
  iconCss: string = "fas fa-search";

  @Input()
  noActions: boolean = false;

  @Input()
  subtitulo: string = '-';

  @Input()
  id: string = 'base-pesquisa-' + Math.random() * 1000;

  @ViewChild('modal') 
  modal!: DialogComponent;

  @Input()
  container: string = 'body';
  
  @Output()
  aberto: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  fechando: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  registroSelecionado: EventEmitter<any> = new EventEmitter<any>();

  constructor(private servico: PesquisaBaseService) { 
    servico.setarComponenteBase(this);
  }

  okSubject: Subject<any> = new Subject<any>();

  ngOnInit() {

  }

  clickOk() {

    if(this.ok)
      this.ok();

    this.okSubject.next(true);

    if(this.gridDiretiva?.grid && this.gridDiretiva?.grid.getSelectedRecords().length > 0) {
      this.registroSelecionado.emit(this.gridDiretiva?.grid.getSelectedRecords()[0]);
      this.fechar();
    }
  }

  abrir() {
    this.modal.show(false);
  }

  abrirTelaCheia() {
    this.modal.show(true);
  }

  public opened() {
  }

  public alterarTelaCheia() {
    this.estaEmTelaCheia = !this.estaEmTelaCheia;
    this.modal.show(this.estaEmTelaCheia);
  }

  canShowContent: boolean = false;
  alreadyOpened: boolean = false;

  executarAntesDeAbrir() {
    this.itemFocadoDiretiva?.item.focusIn();
    this.botaoFocadoDiretiva?.item.focusIn();

    this.abriuModal = true;
    this.aberto.emit();
  }

  fechar() {
    if(this.cancel)
      this.cancel();

    this.modal.hide();
  }

  private ok: () => void = () => { };
  private cancel: () => void = () => { };

  openWithCallback(ok: () => void, cancel: () => void) {
    this.ok = ok;
    this.cancel = cancel;

    this.modal.show(false);
  }

  executarAntesDeFechar(ev: any) {
    this.fechando.next(ev);
  }

  tratarFechamento() {
    let dialogs = document.body.querySelectorAll('ejs-dialog.e-popup-open');
    if(dialogs.length > 0) {
      document.body.classList.add('e-dlg-target');
      document.body.classList.add('e-scroll-disabled');
    }
  } 

}
